export default "__VITE_ASSET__CSPJa6He__"